import GLightbox from 'glightbox';

export function initGlightbox() {
    GLightbox({
        keyboardNavigation: true,
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });
}
